import React from 'react';
import { Spin, Alert } from 'antd';
import isEqual from 'lodash/isEqual';
import { CECSLVUI } from '@/constants';

import './index.less';
const FRAME_APIS = ['networkConstructs'];

export default class ShelfLevelView extends React.Component {
  iframeRef = React.createRef();

  state = {
    ipAddress: undefined,
    iframeLoaded: false,
    slvUnavailable: false,
  };

  interceptIframeRequests = () => {
    const iframeWindow = this.iframeRef.current && this.iframeRef.current.contentWindow;
    if (!iframeWindow) return;

    const handleStatus = (status, url = '') => {
      if (status < 400) return;
      if (FRAME_APIS.some((name) => url.includes(name))) {
        this.setState({ slvUnavailable: true });
      }
    };

    const origFetch = iframeWindow.fetch;
    if (origFetch) {
      iframeWindow.fetch = (...args) =>
        origFetch.apply(iframeWindow, args).then((res) => {
          handleStatus(res.status, res.url);
          return res;
        });
    }

    const OrigXHR = iframeWindow.XMLHttpRequest;
    if (OrigXHR) {
      iframeWindow.XMLHttpRequest = function () {
        const xhr = new OrigXHR();
        xhr.addEventListener('load', () => handleStatus(xhr.status, xhr.responseURL));
        return xhr;
      };
    }
  };

  getIpAddress = () => {
    const { dispatch, simActions } = this.props;
    const { ipAddress } = this.state;

    dispatch({
      type: 'labModel/getLabsVirtualdevices',
      payload: { bookingId: simActions.bookingId, vd_id: simActions.vd_id },
    }).then((virtualDevices) => {
      if (virtualDevices && virtualDevices.length === 1 && virtualDevices[0].api_ip !== ipAddress) {
        this.setState({
          ipAddress: virtualDevices[0].api_ip,
        });
      }
    });
  };

  getSLVSimActions = () => {
    const { simActions } = this.props;
    let slvSimActions = {};

    const extractNums = (locationKey = '') => {
      return locationKey
        .split(/[ /]+/)
        .map((part) => (/^\d+$/.test(part) ? part : null))
        .filter(Boolean);
    };

    const extractType = (label = '') => {
      const SHELF_ARR = ['SHELF'];
      const SLOT_ARR = ['SLOT'];
      const PORT_ARR = ['PORT', 'TTI', 'XCVR', 'LINK'];

      const contains = (str, arr) => {
        const upperStr = str.toUpperCase();
        return arr.some((subStr) => upperStr.includes(subStr));
      };

      if (contains(label, SHELF_ARR)) return 'SHELF';
      if (contains(label, SLOT_ARR)) return 'SLOT';
      if (contains(label, PORT_ARR)) return 'PORT';

      return '';
    };

    const formatActions = (actions = {}, requestObj = {}) => {
      if (!actions.data) return;

      Object.keys(actions.data).forEach((key) => {
        const actionRequestParams = {
          [actions.responseValueParam]: key,
          ...requestObj,
        };

        const locationType = extractType(actions.responseValueParam);
        if (locationType) {
          const locationNums = extractNums(key);
          let location;

          if (locationType === 'SHELF') {
            location = key;
          } else if (locationType === 'SLOT') {
            if (locationNums.length === 1) {
              location = `1::${locationNums[0]}`;
            } else if (locationNums.length === 2) {
              location = `${locationNums[0]}::${locationNums[1]}`;
            } else if (locationNums.length === 3) {
              location = locationNums.join('::');
            }
          } else if (locationType === 'PORT') {
            if (locationNums.length === 1) {
              location = `1::1::${locationNums[0]}`;
            } else if (locationNums.length === 2) {
              location = `1::${locationNums[0]}::${locationNums[1]}`;
            } else if (locationNums.length === 3) {
              location = locationNums.join('::');
            }
          }
          if (location) {
            if (!slvSimActions[location]) {
              slvSimActions[location] = [];
            }
            let options = [];
            if (actions[key] && actions[key].data) {
              Object.keys(actions[key].data).forEach((subkey) => {
                options.push({
                  responseValueParam: actions[key].responseValueParam,
                  value: subkey,
                  label: actions[key].data[subkey],
                });
              });
            }
            slvSimActions[location].push(
              Object.assign(
                {
                  label: actions.sectionLabel,
                  actionRequestParams,
                },
                options.length > 0 ? { options } : {},
              ),
            );
          }
        } else if (actions[key]) {
          formatActions(actions[key], actionRequestParams);
        }
      });
    };

    formatActions(simActions.actions);

    return slvSimActions;
  };

  listenMessageFromIframe = (event) => {
    if (!event.data) return;

    if (event.data.type === 'REQUEST_SIM_ACTIONS') {
      this.postMessageToIframe();
    }

    if (event.data.type === 'PERFORM_SIM_ACTIONS') {
      const { onSLVActionSelect } = this.props;
      const [actionItem, optionItem] = [...event.data.payload];
      const { actionRequestParams } = actionItem;

      if (optionItem) {
        actionRequestParams[optionItem.responseValueParam] = optionItem.value;
      }

      onSLVActionSelect && onSLVActionSelect(actionRequestParams);
    }
  };

  postMessageToIframe = () => {
    if (this.iframeRef.current && this.iframeRef.current.contentWindow) {
      // Override props to SLV
      // this.iframeRef.current.contentWindow.postMessage(
      //   {
      //     type: 'UPDATE_PROPS',
      //     payload: {},
      //   },
      //   '*'
      // );

      this.iframeRef.current.contentWindow.postMessage(
        {
          type: 'UPDATE_SIM_ACTIONS',
          payload: this.getSLVSimActions(),
        },
        '*',
      );
    }
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.simActions, this.props.simActions)) {
      this.setState({ slvUnavailable: false });
      this.postMessageToIframe();

      this.getIpAddress();
    }
  }

  componentDidMount() {
    this.getIpAddress();
    window.addEventListener('message', this.listenMessageFromIframe);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.listenMessageFromIframe);
  }

  render() {
    const {
      simActions: { request_id },
    } = this.props;
    const { ipAddress, iframeLoaded, slvUnavailable } = this.state;

    if (slvUnavailable) {
      return (
        <div className="slv-iframe">
          <div className="iframe-loaded slv-message">
            <Alert
              message="The 'Shelf Level View' is currently unavailable. It may either be unsupported for this device type or the system is busy at the moment."
              type="warning"
              showIcon
            />
          </div>
        </div>
      );
    }

    return (
      <Spin
        wrapperClassName="slv-iframe"
        tip="Loading Shelf Level View"
        size="large"
        spinning={!ipAddress || !iframeLoaded}
      >
        {ipAddress ? (
          <iframe
            className={iframeLoaded ? 'iframe-loaded' : ''}
            ref={this.iframeRef}
            title={`slv_${ipAddress}`}
            src={`${CECSLVUI}/${encodeURIComponent(`${request_id}::${ipAddress}`)}`}
            onLoad={() => {
              this.interceptIframeRequests();
              this.setState({ iframeLoaded: true });
            }}
          />
        ) : (
          <iframe title="slv-loading" />
        )}
      </Spin>
    );
  }
}
